import { render, staticRenderFns } from "./CBProposalEmployees.vue?vue&type=template&id=0cda2153"
import script from "./CBProposalEmployees.vue?vue&type=script&lang=js"
export * from "./CBProposalEmployees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports